export const getTXRoofSurfacesExtended = (roofAge, deductibleWindHail, coverageRSExtended) => {
    if (deductibleWindHail > 1) {
        // if higher than 1, member is paying a flat wind/hail deductible, these always force roof schedule
        return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 0 };
    }
    // force roof schedule based on age and wind/hail deductible
    if (deductibleWindHail === 0.01 && roofAge >= 4) {
        return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 3 };
    }
    if (deductibleWindHail === 0.02 && roofAge >= 7) {
        return { coverageRSExtended: false, stateSpecificLockField: true, stateOverride: true, roofAgeLimit: 6 };
    }
    // all others can pick between schedule or extended roof coverage
    return {
        coverageRSExtended: !!coverageRSExtended,
        stateSpecificLockField: false,
        stateOverride: true,
        roofAgeLimit: 99
    };
};
//# sourceMappingURL=tx-roof-rules.js.map